import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["beforeBack", "children"];
import { useContext } from 'react';
import emptyFunction from 'react-utils/emptyFunction';
import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import UIIcon from 'UIComponents/icon/UIIcon';
import { Button } from 'foundations-components/transitional/components/Button';
import TourContext from '../contexts/TourContext';
import handleCallback from '../lib/handleCallback';
import { jsx as _jsx } from "react/jsx-runtime";
const UITourBackButton = props => {
  const {
    tour
  } = useContext(TourContext);
  const {
      beforeBack = emptyFunction,
      children = /*#__PURE__*/_jsx(FormattedJSXMessage, {
        elements: {
          UIIcon
        },
        options: {
          name: 'left'
        },
        message: "shepherd-react.back_jsx"
      })
    } = props,
    buttonProps = _objectWithoutPropertiesLoose(props, _excluded);
  if (!tour.canGoBack()) {
    return /*#__PURE__*/_jsx("div", {});
  }
  const {
    back,
    getTour,
    getStep
  } = tour;
  const handleClick = evt => {
    const {
      tourKey = getTour(),
      stepKey = getStep()
    } = props;
    if (props.onClick) {
      props.onClick(evt);
    }
    handleCallback(beforeBack, back, {
      tourKey,
      stepKey
    });
  };
  return /*#__PURE__*/_jsx(Button, Object.assign({}, buttonProps, {
    onClick: handleClick,
    children: children
  }));
};
export default UITourBackButton;